import _ from '@lodash';
import { Button } from '@material-ui/core';
import RacsTesztlapService from 'app/admin/racstesztlap/service/RacsTesztlapService';
import { useDispatch } from 'react-redux';
import { showMessage } from 'app/store/fuse/messageSlice';
import { useHistory, withRouter } from 'react-router';
import { useGridCorner } from './GridCornerProvider';

function GridCornerHeader(props) {
	const history = useHistory();
	const { data, setData, getZvbFormat } = useGridCorner();
	const dispatch = useDispatch();

	const handleSave = () => {
		const inputData = getZvbFormat();
		RacsTesztlapService.setGridManual(inputData).then(resp => {
			if (resp) {
				dispatch(showMessage({ message: 'Sikeres mentés.' }));
				history.push('/racstesztlap');
			} else {
				dispatch(showMessage({ message: 'Hiba történt a koordináták rögzítése során.' }));
			}
		});
	};

	return (
		<div className="mt-8">
			<Button variant="contained" color="secondary" disabled={data.length < 2} className="mx-8" onClick={e => handleSave()}>
				Mentés
			</Button>
			<Button variant="contained" color="prtmary" onClick={e => setData([])} className="mx-8">
				Törlés
			</Button>
		</div>
	);
}

export default withRouter(GridCornerHeader);
